import { List, ListItem, Chip, ListItemIcon, ListItemText, ListItemSecondaryAction, IconButton, Typography } from "@material-ui/core";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import Close from "@material-ui/icons/Close";
import { useState } from "react";

import { useDispatch } from "@/store";
import { setSearch } from "@/store/elasticSearch/slice";
import { handleHighlight } from "@/utilities/jsx";
import { deleteRecentSearch, getRecentSearches } from "@/utilities/localStorage/recentSearches";
import { Search } from "@/utilities/types/search";


const RecentSearchList: React.FC = () => {
    const [recentSearches, setRecentSearches] = useState<Search[]>(() => {
        return getRecentSearches().reverse();
    });

    const dispatch = useDispatch();

    const handleDeleteRecentSearch = (search: Search) => {
        const newSearches = deleteRecentSearch(search);

        setRecentSearches(newSearches);
    };

    const useRecentSearch = (newSearch: Search) => {
        dispatch(setSearch(newSearch));
    };

    const renderResultSet = (): JSX.Element[] => {
        const searches = recentSearches.slice(0, 3);

        return searches.map((search, index) => (
            <ListItem
                key={index}
                onClick={()=>{useRecentSearch(search);}}

                button
            >
                <ListItemIcon>
                    <AccessTimeIcon color="action" />
                </ListItemIcon>
                {search.selectedClient && (
                    <Chip style={{ marginRight:8 }} label={search.selectedClient.name} color="secondary" />
                )}
                {search.selectedRegion && (
                    <Chip style={{ marginRight:8 }} label={search.selectedRegion.name} color="secondary" />
                )}
                <ListItemText
                    primary={<Typography variant="body1">{handleHighlight(search.searchQuery)}</Typography>}
                />
                <ListItemSecondaryAction>
                    <IconButton onClick={()=>{handleDeleteRecentSearch(search);}}><Close /></IconButton>
                </ListItemSecondaryAction>
            </ListItem>
        ));
    };

    return (
        <List>{renderResultSet()}</List>
    );
};

export default RecentSearchList;
